import { Link } from "react-router-dom";
import {
  User,
  FolderOpen,
  ArrowRight,
  Github,
  Linkedin,
} from "lucide-react";
import FadingLine from "../Components/FadingLine";
import Footer from "../Components/Footer";

function Home() {
  const skills = [
    "JavaScript",
    "React",
    "Node.js",
    "Python",
    "Java",
    "HTML/CSS",
    "SQL",
    "C++",
    "Git",
  ];

  const quickLinks = [
    {
      title: "View Projects",
      description: "Explore my latest work and development projects",
      icon: <FolderOpen className="w-6 h-6" />,
      path: "/projects",
      color: "from-blue-500 to-purple-600",
    },
    {
      title: "About Me",
      description: "Learn more about my background and experience",
      icon: <User className="w-6 h-6" />,
      path: "/about",
      color: "from-green-500 to-blue-500",
    }
  ];

  return (
    <div className="min-h-screen bg-gray-900 animate-fadeIn">
      {/* Hero Section */}
      <div className="relative overflow-hidden mt-16">
        <div className="absolute inset-0 bg-gradient-to-br from-gray-800 to-gray-900 opacity-50 rounded-lg"></div>
        <div className="relative max-w-6xl mx-auto px-4 py-16 sm:py-24">
          <div className="text-center">
            <h1 className="text-4xl sm:text-6xl font-bold text-white mb-6 animate-slideUp">
              Hi, I'm{" "}
              <span className="bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent">
                Indra Rimal
              </span>
            </h1>

            <p className="text-xl sm:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto animate-slideUp">
              Final-year Software Development student passionate about creating
              user-centric web applications that make a difference.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12 animate-slideUp">
              <Link
                to="/projects"
                className="group bg-gradient-to-r from-green-500 to-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:from-green-600 hover:to-blue-700 transition-all duration-300 flex items-center gap-2"
              >
                View My Work
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Link>

              <Link
                to="/about"
                className="border border-gray-300 text-gray-300 px-8 py-3 rounded-lg font-semibold hover:bg-gray-800 hover:border-gray-200 transition-all duration-300"
              >
                Learn More About Me
              </Link>
            </div>

            {/* Social Links */}
            <div className="flex justify-center gap-6 mb-1">
              <a
                href="https://github.com/indr10"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors duration-300"
                aria-label="GitHub Profile"
              >
                <Github className="w-6 h-6" />
              </a>
              <a
                href="https://www.linkedin.com/in/indra-rimal/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-400 transition-colors duration-300"
                aria-label="LinkedIn Profile"
              >
                <Linkedin className="w-6 h-6" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Skills Section */}
      <div className="max-w-6xl mx-auto px-4 py-16">
        <h2 className="text-3xl font-bold text-white text-center mb-12">
          Technologies I Work With
        </h2>

        <div className="flex flex-wrap justify-center gap-3 mb-3">
          {skills.map((skill, index) => (
            <span
              key={index}
              className="bg-gray-800 text-gray-300 px-4 py-2 rounded-full text-sm font-medium hover:bg-gray-700 transition-colors duration-300 hover:scale-105 animate-fadeIn"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {skill}
            </span>
          ))}
        </div>
      </div>

      <FadingLine />

      {/* Quick Links Section */}
      <div className="max-w-6xl mx-auto px-4 py-16">
        <h2 className="text-3xl font-bold text-white text-center mb-12">
          Explore
        </h2>

        <div className="grid md:grid-cols-2 gap-8">
          {quickLinks.map((link, index) => (
            <Link
              key={index}
              to={link.path}
              className="group relative bg-gray-800 rounded-xl p-6 hover:bg-gray-700 transition-all duration-300 transform hover:scale-105"
            >
              <div
                className={`inline-flex p-3 rounded-lg bg-gradient-to-r ${link.color} text-white mb-4`}
              >
                {link.icon}
              </div>

              <h3 className="text-xl font-semibold text-white mb-2 group-hover:text-green-400 transition-colors">
                {link.title}
              </h3>

              <p className="text-gray-400 group-hover:text-gray-300 transition-colors">
                {link.description}
              </p>

              <ArrowRight className="w-5 h-5 text-gray-400 group-hover:text-green-400 group-hover:translate-x-1 transition-all duration-300 mt-4" />
            </Link>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Home;
